const growthBookClientKey = () => {
  switch (import.meta.env.VITE_API_ENV || 'staging') {
    case 'staging':
      return `sdk-eFTpT8RLWyPteIBZ`;
    case 'production':
      return `sdk-0ts7kyefNLqB5QN`;
    default:
      return `sdk-eFTpT8RLWyPteIBZ`;
  }
};

export { growthBookClientKey };
